module.exports = __webpack_public_path__ + "ye.svg?80d42db316e1c6dc5688926c94e3f2b7";